import React from 'react';
import comms from '../comms';
import FinancialList from './FinancialList';

function Transactions({ userSettings }) {
  return (
    <FinancialList
      userSettings={userSettings}
      fetcher={comms.getDriverTransactions}
      emptyLabel="No transactions found."
    />
  );
}

export default Transactions;
